import { CalendarAvailableDatesResponse, CalendarAvailableHoursResponse, CalendarCreateEventRequest, CalendarCreateEventResponse } from './types';
import { REACT_APP_CALENDAR_API_KEY, REACT_APP_CALENDAR_API_URL, REACT_APP_CALENDAR_DAYS, REACT_APP_CALENDAR_EMAIL, REACT_APP_CALENDAR_SLOT_SIZE  } from '../../config';
import { uuidv4 } from 'services/common';
import * as Sentry from '@sentry/react';

const getCalendarAvailableDates = async (): Promise<CalendarAvailableDatesResponse> => {
  try {
    const response = await fetch(`${REACT_APP_CALENDAR_API_URL}/dates?email=${REACT_APP_CALENDAR_EMAIL}&days=${REACT_APP_CALENDAR_DAYS}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': REACT_APP_CALENDAR_API_KEY,
        'X-User': 'web',
        'X-Request-ID': uuidv4()
      }
    });
    if (!response.ok) {
      Sentry.logger.error('appointmentService[getCalendarAvailableDates] error', { status: response.status, message: await response.text() });
      throw new Error('Error fetching session');
    }

    const data = await response.json() as CalendarAvailableDatesResponse;
    Sentry.logger.info('appointmentService[getCalendarAvailableDates]', { response: data });
    return data;
  } catch (error) {
    console.error('[calendar available dates]', error);
    throw error;
  }
};

const getCalendarAvailableHours = async (date:string): Promise<CalendarAvailableHoursResponse> => {
    try {
      const response = await fetch(`${REACT_APP_CALENDAR_API_URL}/hours?date=${date}&email=${REACT_APP_CALENDAR_EMAIL}&slot_size=${REACT_APP_CALENDAR_SLOT_SIZE}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': REACT_APP_CALENDAR_API_KEY,
          'X-User': 'web',
          'X-Request-ID': uuidv4()
        }
      });
      if (!response.ok) {
        Sentry.logger.error('appointmentService[getCalendarAvailableHours] error', { status: response.status, message: await response.text() });
        throw new Error('Error fetching session');
      }
      const data = await response.json() as CalendarAvailableHoursResponse;
      Sentry.logger.info('appointmentService[getCalendarAvailableHours]', { response: data });

      return data;
    } catch (error) {
      Sentry.logger.error('appointmentService[getCalendarAvailableHours] unexpected error', { error: error });
      console.error('[calendar available hours]', error);
      throw error;
    }
};

const createEventCalendar = async (data:CalendarCreateEventRequest): Promise<CalendarCreateEventResponse> => {
    try {
      const response = await fetch(`${REACT_APP_CALENDAR_API_URL}/event-create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': REACT_APP_CALENDAR_API_KEY,
          'X-User': 'web',
          'X-Request-ID': uuidv4()
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        Sentry.logger.error('appointmentService[createEventCalendar] error', { status: response.status, message: await response.text() });
        throw new Error('Error fetching session');
      }

      const r = await response.json() as CalendarCreateEventResponse;
      Sentry.logger.info('appointmentService[createEventCalendar]', { response: r });
      return r;
    } catch (error) {
      Sentry.logger.error('appointmentService[createEventCalendar] unexpected error', { error: error });
      console.error('[calendar available hours]', error);
      throw error;
    }
};

export { getCalendarAvailableDates, getCalendarAvailableHours, createEventCalendar };